import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, showMessageToastCustom } from '../../../../utils/util';
import { Breadcrumbs, Button, Card, Input } from '../../../../components/UI/ComponentsUI';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import StockService from '../../../../services/StockService';

export const UploadPartNumber = (props) => {
    const [selectedFile, setSelectedFile] = useState();
    const [messages, setMessages] = useState([]);
    const [upload, setUpload] = useState({
        inicialDate: "",
        finalDate: ""
    });

    const onConfirm = () => {
        if (validateInputsRequired("formUpload")) {
            const data = {
                ...upload,
                inicialDate: upload?.inicialDate,
                finalDate: upload?.finalDate
            }

            props.uploadDropMaterial(data, selectedFile, (response) => {
                if (response.length === 0) {
                    showMessageToastCustom(translate('general.info'), "Arquivo processado com sucesso.", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    props.history.go(-1);
                }
                setMessages(response);
            });
        }
    };

    const onChange = (event) => {
        onValueChange(event, upload, setUpload);
    };

    return (
        <div>
            <Breadcrumbs id="upload" title={{ icon: "mdi mdi-clipboard-check-outline", label: "Upload de Difusão" }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className='container'>
                    <Card>
                        <div id="formUpload" className="row" >
                            <div className="input-field col s6 no-padding m6">
                                <span style={{ color: "#9e9e9e" }} >{translate('date-start', 'truck-kanban')}</span>
                                <Input
                                    required
                                    defaultValue={upload.inicialDate}
                                    type="datetime-local"
                                    id="inicialDate"
                                    name="inicialDate"
                                    onChange={onChange}
                                />
                            </div>
                            <div className="input-field col s5 no-padding m5">
                                <span style={{ color: "#9e9e9e" }} >{translate('date-end', 'truck-kanban')}</span>
                                <Input
                                    required
                                    defaultValue={upload.finalDate}
                                    type="datetime-local"
                                    id="finalDate"
                                    name="finalDate"
                                    onChange={onChange}
                                />
                            </div>
                            <div className="input-field no-padding col s12">
                                <input
                                    required
                                    type="file"
                                    onChange={(event) => setSelectedFile(event.target.files[0])} />
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: '10px' }}>
                            <div className="col s6">
                                <Button full="true" onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            </div>
                            <div className="col s6">
                                <Button full="true" onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </Card>
                    {
                        messages.length > 0 &&
                        <div style={{ display: 'flex', flexDirection: 'column', padding: '5px 15px 0px' }}>
                            {messages.map((item, index) => (
                                < span key={index} className={"fourth-text-color"} >
                                    {item}
                                </span>
                            ))}
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};


const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        uploadDropMaterial: (upload, selectedFile, callback) => {
            dispatch(StockService.uploadFile(upload, selectedFile, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UploadPartNumber));
